module.exports = __webpack_public_path__ + "img/helpninja-logo-blue.eba665d8.svg";